import { ReactComponent as RightIconSVG } from '../../../static/chevron_right_black_24dp.svg';
import { generateStyledIcon } from '../Arrow.styles';

export const S = {
  RightArrowIcon: generateStyledIcon(RightIconSVG),
};
